import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const LINKS = [
  ["Home", "#home", "nav-home-link"],
  ["Fleet", "#fleet", "nav-fleet-link"],
  ["Services", "#services", "nav-services-link"],
  ["About", "#about", "nav-about-link"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  return (
    <motion.header className="nav" initial={{ y: -70, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}>
      <a data-testid="brand-link" className="brand" href="#home">
        <Logo />
        <span className="brand-name"><strong>KRISHNA</strong><small>GENERATOR SERVICE</small></span>
      </a>
      <nav data-testid="main-navigation" className={open ? "nav-links open" : "nav-links"}>
        {LINKS.map(([label, href, id]) => (
          <a key={id} data-testid={id} className="nav-link" href={href} onClick={() => setOpen(false)}>{label}</a>
        ))}
        <a data-testid="nav-admin-link" className="nav-link" href="/admin">Admin</a>
        <a data-testid="nav-quote-button" className="nav-cta" href="#booking" onClick={() => setOpen(false)}>
          Get a quote <ArrowUpRight size={15} />
        </a>
      </nav>
      <button data-testid="mobile-menu-button" className="nav-burger" onClick={() => setOpen(!open)} aria-label="Menu">
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
    </motion.header>
  );
};
